import { FormlyFieldConfig } from '@ngx-formly/core';
import { RangeValidatorError } from '@portal/form/data-access';

export function percentageMessage(_error: unknown, _field: FormlyFieldConfig): string {
  return `The number should be less than 100`;
}

export function rangeMessage(error: RangeValidatorError, field: FormlyFieldConfig): string {
  // error expected shape: { range: { min?: number, max?: number, actual?: number } }
  const fromError = error?.range;

  // fallback to field.props.range when error doesn't include min/max
  const propsRange = (field?.props as any)?.range as { min?: number; max?: number } | undefined;

  const minFromError = fromError && typeof fromError.min === 'number' ? fromError.min : undefined;
  const maxFromError = fromError && typeof fromError.max === 'number' ? fromError.max : undefined;

  const min = typeof minFromError === 'number' ? minFromError : propsRange?.min;
  const max = typeof maxFromError === 'number' ? maxFromError : propsRange?.max;

  const fmt = (n?: number) => (typeof n === 'number' ? n.toLocaleString('en-US') : undefined);

  if (typeof min === 'number' && typeof max === 'number') {
    if (min === max) {
      return `The number must be ${fmt(min)}.`;
    }
    return `The number must be between ${fmt(min)} and ${fmt(max)}.`;
  }
  if (typeof min === 'number') {
    return `The number must be greater than or equal to ${fmt(min)}.`;
  }
  if (typeof max === 'number') {
    return `The number must be less than or equal to ${fmt(max)}.`;
  }

  // Generic fallback
  return `The number is out of the allowed range.`;
}
